import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  formatBytes,
  readPDFFile,
  renderPDFPage,
  readEncryptedPDFFileAsArrayBuffer,
  getFileExtension,
  saveFile,
  readPDFFileAsArrayBuffer,
} from "../Utils";
import { PDFDocument } from "pdf-lib-plus-encrypt";
import { resizePDFDocument } from "../PDFHelper/PDFRenderer";
import PDFViewerView from "../pdf_viewer/PDFViewerView";

function ResizePDFImageListScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, index etc key is filepath
  const [pdfInfo, setPdfInfo] = useState({
    state: AppState.NONE,
    thumbnail: null,
    pageCount: 0,
    dimension: [0, 0],
    message: "",
    locked: false,
    password: "",
    name: "---",
    file: null, //selected file
    size: 0, //in bytes
    resized_blob: null,
    resized_size: 0,
  });
  //item displaying in password input modal
  const [selectedItemForPasswordInput, setSelectedItemForPasswordInput] =
    useState(null);
  //password input modal input field reference
  //get password value
  const passwordInputModalInputRef = useRef(null);
  //output settings
  const [outputSettings, setOutputSettings] = useState({
    width: 100,
    height: 100,
    linked: true,
  });
  //is resizing
  const [isResizing, setIsResizing] = useState(false);

  //show pdf preview
  const [showPDFPreview, setShowPDFPreview] = useState({
    preview: false,
    file: null,
    password: "",
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //check
      if (selectedFiles.length > 0) {
        //process pdf file
        processPDFFile(selectedFiles[0], "");
      }

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    //check
    //if locked and password not set
    if (pdfInfo.locked === true && pdfInfo.password === "") {
      //show password field
      setSelectedItemForPasswordInput(selectedFiles[0]);
      //click to focus modal
      document.getElementById("passwordModal").click();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles, pdfInfo]);

  //fetch pdf file as data
  //get thumbnail
  //chek if password protected
  //unlock if provided correct password
  //render file
  const processPDFFile = async (selectedFile, password) => {
    //try - catch
    try {
      //read pdf file
      const data = await readPDFFile(selectedFile);
      //thumbnail
      await renderPDFPage(data, password, "image/jpeg", 0.2, 0).then(
        ([img, numPages, dimension]) => {
          //set dimension
          setOutputSettings({
            ...outputSettings,
            width: dimension[0],
            height: dimension[1],
          });

          //set pdf info
          setPdfInfo({
            ...pdfInfo,
            state: AppState.LOADED,
            thumbnail: img,
            pageCount: numPages,
            dimension: dimension,
            message: "",
            locked: false,
            password: password,
            name: selectedFile.name,
            file: selectedFile, //selected file
            size: selectedFile.size, //in bytes
            resized_blob: null,
            resized_size: 0,
          });
        },
      );
    } catch (e) {
      //check
      if (e.name === "PasswordException") {
        //set pdf info
        setPdfInfo({
          ...pdfInfo,
          state: AppState.NONE,
          pageCount: 0,
          dimension: [0, 0],
          message: "",
          locked: true,
          password: "",
          name: selectedFile.name,
          file: selectedFile, //selected file
          size: selectedFile.size, //in bytes
          resized_blob: null,
          resized_size: 0,
        });
      } else {
        //set pdf info
        setPdfInfo({
          ...pdfInfo,
          state: AppState.NONE,
          pageCount: 0,
          dimension: [0, 0],
          message: "Can not load file. Something went wrong.",
          locked: false,
          password: "",
          name: selectedFile.name,
          file: selectedFile, //selected file
          size: selectedFile.size, //in bytes
          resized_blob: null,
          resized_size: 0,
        });
      }
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setPdfInfo({
      ...pdfInfo,
      state: AppState.NONE,
      thumbnail: null,
      pageCount: 0,
      message: "",
      locked: false,
      password: "",
      name: "---",
      file: null, //selected file
      size: 0, //in bytes
      resized_blob: null,
      resized_size: 0,
    });
    setShowEditFileScreen(false);
    setStartProcessingFiles(false);
  };

  //on change dimension inputs
  const onChangeDimensionInputs = (e) => {
    //check
    if (pdfInfo.dimension[0] === 0 || pdfInfo.dimension[1] === 0) {
      //return
      return;
    }

    //ratio
    const ratio = pdfInfo.dimension[0] / pdfInfo.dimension[1];
    //set
    //change w.r.t aspect ratio
    //if linked
    setOutputSettings({
      ...outputSettings,
      width:
        e.target.id === "height"
          ? outputSettings.linked
            ? Math.floor(e.target.value * ratio)
            : outputSettings.width
          : e.target.value,
      height:
        e.target.id === "width"
          ? outputSettings.linked
            ? Math.floor(e.target.value * (1 / ratio))
            : outputSettings.height
          : e.target.value,
    });
  };

  //render password input modal
  const renderPassordInputModal = (item) => {
    return (
      <div
        className="modal fade"
        id="passwordInputModal"
        tabIndex="-1"
        aria-labelledby="passwordInputModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="passwordInputModalLabel">
                {item !== null ? item.name : "Failed loading file"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="password" className="col-form-label">
                    Unlock pdf to continue. Enter password below:
                  </label>
                  <input
                    type="password"
                    className="form-control mt-2"
                    id="password"
                    placeholder="Type password here..."
                    ref={passwordInputModalInputRef}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                  //process pdf
                  processPDFFile(item, pdfInfo.password);
                }}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={async (e) => {
                  //process file
                  await processPDFFile(
                    item,
                    passwordInputModalInputRef.current.value,
                  );
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                }}
              >
                Unlock
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        data-bs-toggle={`${pdfInfo.locked === true ? "modal" : ""}`}
        data-bs-target={`${
          pdfInfo.locked === true ? "#passwordInputModal" : ""
        }`}
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //check
          //if locked
          if (pdfInfo.locked === true) {
            //show password field
            //set item
            setSelectedItemForPasswordInput(item);
          } else {
            //set preview
            setShowPDFPreview({
              ...showPDFPreview,
              preview: true,
              file:
                pdfInfo.resized_blob === null
                  ? pdfInfo.file
                  : pdfInfo.resized_blob,
              password: pdfInfo.password,
            });
          }
        }}
      >
        {/* Flex container left image pdf right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  pdfInfo.thumbnail != null
                    ? pdfInfo.thumbnail
                    : "./images/file_icon.png"
                }
                alt="pdf_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size:{" "}
                {pdfInfo.state === AppState.PROCESSED
                  ? formatBytes(pdfInfo.resized_size)
                  : formatBytes(item.size)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  pdfInfo.state === AppState.PROCESSED
                    ? "text-success"
                    : "bg-danger text-white"
                }`}
              >
                {pdfInfo.state === AppState.PROCESSED
                  ? "RESIZED"
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Page Count */}
            <div className="px-2 fs-6 text-body-secondary">
              {pdfInfo.pageCount} Pages, Dimension: {pdfInfo.dimension[0]} X{" "}
              {pdfInfo.dimension[1]}
            </div>
            {/* Lock Message */}
            <div
              className={`px-2 text-danger fs-6 mt-3 fw-bold ${
                pdfInfo.locked === true ? "" : "d-none"
              }`}
            >
              Locked. Click to unlock.
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                pdfInfo.message !== "" ? "" : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {pdfInfo.message}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          {/* Download Button */}
          {/* Show download button after processed */}
          <div
            className="position-absolute  justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            <div
              className={`my-auto me-2 ms-1 ${
                pdfInfo.state === AppState.PROCESSED ? "" : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={async (e) => {
                  //stop propagating
                  e.stopPropagation();
                  //blob
                  const blob = pdfInfo.resized_blob;
                  //save
                  await saveFile(blob, pdfInfo.name + ".pdf");
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                </svg>
              </button>
            </div>
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-1 ${
                pdfInfo.state === AppState.PROCESSING ? "" : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                pdfInfo.state === AppState.LOADED ||
                pdfInfo.state === AppState.NONE
                  ? ""
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* show pdf preview */}
      {/* page main content */}
      {showPDFPreview.preview ? (
        <PDFViewerView
          title={showPDFPreview.file === null ? "" : showPDFPreview.file.name}
          password={showPDFPreview.password}
          onClose={() => {
            //set preview
            setShowPDFPreview({
              ...showPDFPreview,
              preview: false,
              file: null,
              password: "",
            });
          }}
          file={showPDFPreview.file}
        ></PDFViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Resize PDF Files"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
            data-bs-toggle={`${pdfInfo.locked ? "modal" : ""}`}
            data-bs-target={`${pdfInfo.locked ? "#passwordInputModal" : ""}`}
            id="passwordModal"
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* Label output dimension */}
              <div>
                <div className="d-flex mt-5 ms-4 me-4 border-bottom">
                  <label
                    htmlFor="outputDimension"
                    className="form-label fs-4 text-dark"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Output pdf page dimension"
                  >
                    Output Dimension:
                  </label>
                </div>

                {/* Dimension input */}
                <div className="ms-4 mt-4">
                  <div className="d-block position-relative">
                    <div className="d-block">
                      {/* Width */}
                      <div className="d-flex">
                        {/* label */}
                        <label className="me-2 my-auto text-secondary">
                          Width:
                        </label>
                        <input
                          className="form-control"
                          id="width"
                          placeholder="width"
                          value={outputSettings.width}
                          type="number"
                          style={{ width: "100px", maxWidth: "100px" }}
                          onChange={onChangeDimensionInputs}
                        ></input>
                      </div>

                      {/* Height */}
                      <div className="d-flex mt-5">
                        {/* label */}
                        <label className="me-2 my-auto text-secondary">
                          Height:
                        </label>
                        <input
                          className="form-control"
                          id="height"
                          placeholder="height"
                          value={outputSettings.height}
                          type="number"
                          style={{ width: "100px", maxWidth: "100px" }}
                          onChange={onChangeDimensionInputs}
                        ></input>
                      </div>
                    </div>
                    {/* Lock Aspect Ratio */}
                    <img
                      loading="lazy"
                      className="position-absolute opacity-50"
                      src={
                        outputSettings.linked
                          ? "./images/lock-fill.svg"
                          : "./images/unlock-fill.svg"
                      }
                      alt="link"
                      style={{
                        top: "calc(50% - 12px)",
                        left: "100px",
                        width: "24px",
                        height: "auto",
                        maxWidth: "24px",
                        maxHeight: "24px",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        //toggle
                        setOutputSettings({
                          ...outputSettings,
                          linked: outputSettings.linked ? false : true,
                        });
                      }}
                    />
                  </div>
                  {/* Reset button */}
                  <button
                    className="btn btn-outline-secondary mt-5 ms-5"
                    type="button"
                    onClick={(e) => {
                      //blur
                      e.currentTarget.blur();
                      //reset dimensions
                      setOutputSettings({
                        ...outputSettings,
                        width: pdfInfo.dimension[0],
                        height: pdfInfo.dimension[1],
                        linked: true,
                      });
                    }}
                  >
                    <img
                      loading="lazy"
                      className="me-2"
                      alt="reset"
                      src="./images/arrow-counterclockwise.svg"
                    />
                    Reset
                  </button>
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isResizing ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                  lineHeight: "1.1",
                }}
                type="button"
                onClick={async (e) => {
                  //blur
                  e.currentTarget.blur();

                  //check
                  //if indices not defined
                  //return
                  if (selectedFiles.length === 0) {
                    //return
                    return;
                  }

                  //set
                  setIsResizing(true);
                  //set state
                  setPdfInfo({
                    ...pdfInfo,
                    state: AppState.PROCESSING,
                    message: `Reading file...`,
                  });

                  //try catch
                  try {
                    //read pdf file
                    let data = await readPDFFileAsArrayBuffer(selectedFiles[0]);
                    // Load a PDF with form fields
                    //if encrypted
                    //proceed to catch block
                    const pdfDoc = await PDFDocument.load(data);

                    //resize pdf
                    await resizePDFDocument(
                      "Resized PDF",
                      pdfDoc,
                      [
                        Number(outputSettings.width),
                        Number(outputSettings.height),
                      ],
                      pdfInfo.password,
                      (perct) => {
                        //set state
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSING,
                          message: `Resizing file ${Math.floor(perct * 100)}%`,
                        });
                      },
                      (blob) => {
                        //set
                        //set blob
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSED,
                          message: `Successfully resized. Resized pdf will be downloaded automatically on your device.`,
                          resized_blob: blob,
                          resized_size:
                            blob === null ? formatBytes(0) : blob.size,
                        });
                        //check
                        if (blob !== null) {
                          //save blob
                          saveFile(blob, pdfInfo.name);
                        }
                      },
                    );
                  } catch {
                    //decrypy pdf using pdfjsLib
                    //read pdf file
                    //as pdf-lib does not decrypt encrypted we need pdfjslib to decrypt it
                    let data = await readEncryptedPDFFileAsArrayBuffer(
                      selectedFiles[0],
                      pdfInfo.password,
                      (perct) => {
                        //set state
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSING,
                          message: `Reading file ${Math.floor(perct * 100)}%`,
                        });
                      },
                    );

                    //check
                    if (data === null) {
                      //set
                      //set blob
                      setPdfInfo({
                        ...pdfInfo,
                        state: AppState.PROCESSED,
                        message: `Failed resizing pdf. Try again later.`,
                        resized_blob: null,
                        resized_size: 0,
                      });
                    } else {
                      //set state
                      setPdfInfo({
                        ...pdfInfo,
                        state: AppState.PROCESSING,
                        message: `Loading file...`,
                      });
                      // Load a PDF with form fields
                      //if encrypted
                      //proceed to ctch block
                      const pdfDoc = await PDFDocument.load(data);

                      //resize pdf
                      await resizePDFDocument(
                        "Resized PDF",
                        pdfDoc,
                        [
                          Number(outputSettings.width),
                          Number(outputSettings.height),
                        ],
                        pdfInfo.password,
                        (perct) => {
                          //set state
                          setPdfInfo({
                            ...pdfInfo,
                            state: AppState.PROCESSING,
                            message: `Resizing file ${Math.floor(
                              perct * 100,
                            )}%`,
                          });
                        },
                        async (blob) => {
                          //set
                          //set blob
                          setPdfInfo({
                            ...pdfInfo,
                            state: AppState.PROCESSED,
                            message: `Successfully resized. Resized pdf will be downloaded automatically on your device.`,
                            resized_blob: blob,
                            resized_size:
                              blob === null ? formatBytes(0) : blob.size,
                          });
                          //check
                          if (blob !== null) {
                            //save blob
                            await saveFile(blob, pdfInfo.name);
                          }
                        },
                      );
                    }
                  }
                  //read pdf file
                  //reset
                  setIsResizing(false);
                }}
              >
                RESIZE
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Password input modal */}
      {renderPassordInputModal(selectedItemForPasswordInput)}
    </div>
  );
}

export default ResizePDFImageListScreen;
